<ng-container *ngIf="hasFareInfo">
  <app-alert-message *ngIf="hasTextFare" [text]="textFare" [alertType]="alertType"></app-alert-message>
  <app-alert-message *ngIf="shouldDisplayExtraTextFare" [text]="extraTextFare" [alertType]="alertType"></app-alert-message>
</ng-container>
